(() => {
  const root = document.querySelector('[data-essenca-reviews]');
  const reviews = Array.isArray(window.essencaReviews) ? window.essencaReviews : [];

  if (!root || reviews.length === 0) return;

  const state = {
    filter: 'one',
    limit: 12,
  };

  const themes = [
    {
      value: 'Scent experience',
      detail: 'scent, smell, fragrance or aroma',
      test: /smell|scent|fragrance|aroma/i,
    },
    {
      value: 'Easy to use',
      detail: 'easy, simple or setup',
      test: /\beasy\b|\bsimple\b|set.?up|follow the directions/i,
    },
    {
      value: 'Cordless & portable',
      detail: 'cordless, battery, charging or placement',
      test: /cordless|wireless|battery|charg|anywhere|travel|move it|work desk|salon|bathroom/i,
    },
  ];

  const selectors = {
    heading: '.essenca-reviews__heading h1',
    summary: '[data-review-summary]',
    filters: '[data-review-filters]',
    featured: '[data-review-featured]',
    percentages: '[data-review-percentages]',
    wallIntro: '[data-review-wall-intro]',
    status: '[data-review-status]',
    grid: '[data-review-grid]',
    moreWrap: '[data-review-more-wrap]',
  };

  const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
  })[character]);

  const formatDate = (value) => {
    const [year, month, day] = value.split('-').map(Number);
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(new Date(Date.UTC(year, month - 1, day)));
  };

  const stars = (rating) => {
    const rounded = Math.round(rating * 2) / 2;
    const full = Math.floor(rounded);
    const half = rounded % 1 ? '½' : '';
    const empty = 5 - Math.ceil(rounded);
    return `<span class="essenca-reviews__stars" role="img" aria-label="${rounded} out of 5 stars"><span aria-hidden="true">${'★'.repeat(full)}${half}${'☆'.repeat(empty)}</span></span>`;
  };

  const stats = (rows) => {
    const total = rows.length;
    const average = total ? rows.reduce((sum, review) => sum + review.rating, 0) / total : 0;
    return { total, average };
  };

  const productNameFor = (product) => product === 'pod' ? 'ScentPods' : 'Essénca ONE';

  const layoutCards = () => {
    const grid = root.querySelector(selectors.grid);
    if (!grid) return;

    const cards = [...grid.querySelectorAll('.essenca-reviews__card')];
    cards.forEach((card) => { card.style.gridRowEnd = ''; });

    if (window.matchMedia('(max-width: 760px)').matches) {
      grid.style.gridAutoRows = 'auto';
      return;
    }

    grid.style.gridAutoRows = '8px';
    const rowHeight = 8;
    const rowGap = Number.parseFloat(getComputedStyle(grid).rowGap) || 18;
    cards.forEach((card) => {
      const cardHeight = card.getBoundingClientRect().height;
      card.style.gridRowEnd = `span ${Math.ceil((cardHeight + rowGap) / (rowHeight + rowGap))}`;
    });
  };

  const render = ({ preserveScroll = false, focusSelector = '' } = {}) => {
    const previousScroll = window.scrollY;
    const oneRows = reviews.filter((review) => review.product === 'one');
    const podRows = reviews.filter((review) => review.product === 'pod');
    const filteredRows = reviews.filter((review) => review.product === state.filter);
    const writtenRows = filteredRows
      .filter((review) => review.text)
      .sort((a, b) => b.date.localeCompare(a.date));
    const displayRows = writtenRows.filter((review) => review.rating !== 1);
    const visibleRows = displayRows.slice(0, state.limit);
    const currentStats = stats(filteredRows);
    const productName = productNameFor(state.filter);
    const preferredIds = state.filter === 'pod'
      ? ['review-001', 'review-002', 'review-049']
      : ['review-003', 'review-008', 'review-017'];
    const featuredRows = preferredIds
      .map((id) => displayRows.find((review) => review.id === id))
      .filter(Boolean);

    displayRows
      .filter((review) => review.rating === 5 && !featuredRows.some((featured) => featured.id === review.id))
      .slice(0, Math.max(0, 3 - featuredRows.length))
      .forEach((review) => featuredRows.push(review));

    const themeSignals = themes.map((theme) => {
      const positiveCount = writtenRows.filter((review) => review.rating >= 4 && theme.test.test(review.text)).length;
      return {
        ...theme,
        positiveCount,
        percent: writtenRows.length ? Math.round((positiveCount / writtenRows.length) * 100) : 0,
      };
    });

    root.querySelector(selectors.heading).innerHTML = `What customers say<br><em>about ${productName}.</em>`;
    root.querySelector(selectors.summary).setAttribute('aria-label', `${currentStats.average.toFixed(1)} average rating for ${productName}`);
    root.querySelector(selectors.summary).innerHTML = `${stars(currentStats.average)}<strong>${currentStats.average.toFixed(1)} average</strong>`;
    root.querySelector(selectors.filters).innerHTML = `
      <button type="button" data-review-filter="one" aria-pressed="${state.filter === 'one'}">Essénca ONE <span>${oneRows.length}</span></button>
      <button type="button" data-review-filter="pod" aria-pressed="${state.filter === 'pod'}">ScentPods <span>${podRows.length}</span></button>`;
    root.querySelector(selectors.featured).innerHTML = featuredRows.map((review) => `
      <article class="essenca-reviews__featured-card">
        <span class="essenca-reviews__quote-mark" aria-hidden="true">“</span>
        ${stars(review.rating)}
        <blockquote>${escapeHtml(review.text)}</blockquote>
        <footer>
          <strong>TikTok Shop review</strong>
          <span><time datetime="${review.date}">${formatDate(review.date)}</time> · ${productNameFor(review.product)}</span>
        </footer>
      </article>`).join('');
    root.querySelector(selectors.percentages).innerHTML = themeSignals.map((theme) => `
      <article class="essenca-reviews__percentage-card">
        <strong>${theme.percent}%</strong>
        <h3>${theme.value}</h3>
        <p>${theme.positiveCount} of ${writtenRows.length} written reviews are rated 4–5 stars and mention ${theme.detail}.</p>
      </article>`).join('');
    root.querySelector(selectors.wallIntro).textContent = `Selected 2–5 star comments for ${productName}, shown without rewriting.`;
    root.querySelector(selectors.status).textContent = `Showing ${visibleRows.length} of ${displayRows.length} selected reviews · newest first`;
    root.querySelector(selectors.grid).innerHTML = visibleRows.map((review) => `
      <article class="essenca-reviews__card">
        <header>${stars(review.rating)}<time datetime="${review.date}">${formatDate(review.date)}</time></header>
        <blockquote>“${escapeHtml(review.text)}”</blockquote>
        <footer><strong>TikTok Shop review</strong><span>${productNameFor(review.product)}</span></footer>
      </article>`).join('');
    root.querySelector(selectors.moreWrap).innerHTML = visibleRows.length < displayRows.length
      ? '<button type="button" data-review-more>Show 12 more reviews</button>'
      : '';

    requestAnimationFrame(() => {
      layoutCards();
      if (preserveScroll) window.scrollTo({ top: previousScroll, behavior: 'instant' });
      if (focusSelector) root.querySelector(focusSelector)?.focus({ preventScroll: true });
    });
  };

  root.addEventListener('click', (event) => {
    const filterButton = event.target.closest('[data-review-filter]');
    if (filterButton) {
      state.filter = filterButton.dataset.reviewFilter;
      state.limit = 12;
      render({ preserveScroll: true, focusSelector: `[data-review-filter="${state.filter}"]` });
      return;
    }

    const moreButton = event.target.closest('[data-review-more]');
    if (moreButton) {
      state.limit += 12;
      render({ preserveScroll: true, focusSelector: '[data-review-more]' });
    }
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(layoutCards, 120);
  });

  render();
})();
